export default "__VITE_ASSET__3c00af35__"